import { jsx } from 'panel';
import { ChartLegendEl } from 'common/components/chart-legend';
import { ChartTooltipEl } from 'common/components/chart-tooltip';
import { ActionsPopoverEl } from 'common/widgets/actions-popover';
import { LegendLineChartEl } from 'common/widgets/legend-line-chart';
import { FunnelsBarChartEl } from '../bar-chart';
export function template() {
  const {
    chartTooltip,
    popoverActive
  } = this.state;
  return jsx("div", {
    sel: '.funnel-frequency-chart',
    class: {
      hidden: this.helpers.isHidden(),
      'download-mode': this.attr("download-mode")
    }
  }, this.helpers.hasData() && this.attr("include-header") ? jsx("div", {
    sel: '.header'
  }, jsx("div", {
    sel: '.labels'
  }, (() => {
    const subtitleText = this.helpers.subtitleText();
    return subtitleText ? jsx(null, null, jsx("span", {
      sel: '.description.mp-font-weight-medium'
    }, subtitleText.totalInStepText), jsx("span", {
      sel: '.conversion-amount'
    }, subtitleText.conversionText)) : null;
  })())) : null, jsx("div", {
    sel: '.body'
  }, !this.helpers.hasData() ? jsx("slot", {
    attrs: {
      name: "empty-state"
    }
  }) : jsx(null, null, this.helpers.showBarChart() ? (() => {
    const {
      data,
      isTruncated
    } = this.helpers.barChartData();
    return jsx(null, null, jsx("div", {
      sel: '.chart-container'
    }, popoverActive ? jsx(ActionsPopoverEl, {
      sel: '.frequency',
      attrs: Object.assign(Object.assign(Object.assign({}, this.helpers.popoverAttrs()), this.helpers.getPopover().attrs()), {
        open: popoverActive
      }),
      style: this.helpers.getPopoverPlacement(),
      on: Object.assign(Object.assign({}, this.helpers.popoverEventHandlers()), this.helpers.closePopover())
    }, this.helpers.getPopover().body()) : null, jsx(FunnelsBarChartEl, {
      attrs: {
        'interval-title': "Frequency",
        'disable-tooltip': popoverActive,
        'display-relative': this.attr("value-representation") === this.helpers.ValueRepresentationType.Relative
      },
      on: {
        clickBar: this.helpers.clickBar,
        hoverBar: this.helpers.hoverBar,
        offHoverBar: this.helpers.offHoverBar,
        scroll: this.helpers.popover.closePopover
      },
      props: {
        data
      }
    }), this.attr("legend-sections") ? jsx(ChartLegendEl, {
      attrs: this.helpers.chartLegendAttrs(),
      on: {
        togglecheckbox: this.helpers.passThrough
      }
    }) : null, chartTooltip ? (() => {
      const {
        color,
        sections,
        left,
        top
      } = chartTooltip;
      return jsx("div", {
        sel: '.hover-tooltip',
        style: {
          left: "".concat(left, "px"),
          top: "".concat(top, "px")
        }
      }, jsx(ChartTooltipEl, {
        attrs: this.helpers.getChartToolTipAttrs(sections, color, null)
      }));
    })() : null), isTruncated ? jsx("div", {
      sel: '.truncation-notice'
    }, "Results have been truncated to the first 30 results for download") : null);
  })() : jsx(LegendLineChartEl, {
    attrs: {
      'display-analysis-type': "linear",
      'display-context': this.attr("display-context"),
      'download-mode': this.attr("download-mode"),
      'is-compact': this.attr("is-compact"),
      'is-segmented': this.helpers.isSegmented(),
      'legend-sections': this.attr("legend-sections"),
      'legend-theme': this.attr("legend-theme"),
      'show-popover': true,
      timezone: this.attr("timezone"),
      'utc-offset': this.attr("utc-offset")
    },
    on: {
      togglecheckbox: this.helpers.passThrough
    },
    props: {
      chartData: this.helpers.lineChartData(),
      formatTooltip: this.helpers.formatTooltip,
      formatXAxisLabel: this.helpers.formatXAxisLabel,
      formatYAxisLabel: this.helpers.formatYAxisLabel,
      onHighChartClick: this.helpers.lineChartClick,
      popover: this.helpers.getPopover
    }
  }))));
}